import { createSlice } from "@reduxjs/toolkit";
import { defaultLanguage } from "../../utils/constants";
const initialState = {
  searchUserTerm: "",
  users: [],
  searchUserLoading: false,
  page: 1,
  offset: 0,
  pageSize: 12,
  hasMoreUsers: true,
  loading: false,
  open: null,
  userDetails: {},
  userEditBoxHeight: 0,
  userAccess: [],
  languages: [],
  roles: [],
  subRoles: [],
  userUpdateDetails: {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    role: "",
    subRole: "",
    additionalAccess: [],
    language: "",
  },
  error: {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    role: "",
    subRole: "",
  },
  userDetailsLoading: false,
  isformDataChange: false,
  onSubmitLoading: false,
  onRemoveLoading: false,
  removeUserPopper: false,

  newUser: {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    role: "",
    subRole: "",
    additionalAccess: [],
    language: defaultLanguage.en,
  },
  newUserError: {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    role: "",
    subRole: "",
  },
  newUserOpen: false,
  onNewUserSubmitLoading: false,
  isNewUserFormDataChange: false,
  isAdminCheck: false,

  isAdminCheckForUpdate: true,
  toggle: true,
};

const userListSlice = createSlice({
  name: "userList",
  initialState,
  reducers: {
    reset(state) {
      state.searchUserTerm = "";
      state.users = [];
      state.searchUserLoading = false;
      state.page = 1;
      state.offset = 0;
      state.pageSize = 12;
      state.hasMoreUsers = true;
      state.loading = false;
      state.open = null;
      state.userDetails = {};
      state.userEditBoxHeight = 0;
      // state.userAccess = [];
      // state.languages = [];
      // state.roles = [];
      state.userUpdateDetails = {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        role: "",
        subRole: "",
        additionalAccess: [],
        language: "",
      };
      state.error = {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        role: "",
        subRole: "",
      };
      state.userDetailsLoading = false;
      state.isformDataChange = false;
      state.onSubmitLoading = false;
      state.onRemoveLoading = false;
      state.removeUserPopper = false;

      state.newUser = {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        role: "",
        subRole: "",
        additionalAccess: [],
        language: defaultLanguage.en,
      };
      state.newUserError = {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        role: "",
        subRole: "",
      };
      state.newUserOpen = false;
      state.onNewUserSubmitLoading = false;
      state.isNewUserFormDataChange = false;
      state.isAdminCheck = false;

      state.isAdminCheckForUpdate = true;
      state.toggle = true;
    },
    setSearchUserTerm(state, action) {
      state.searchUserTerm = action.payload;
    },
    getAllUserList(state) {
      if (!state.hasMoreUsers || state.loading) return;
      state.loading = true;
    },
    setAllUserList(state, action) {
      if (!action.payload.users.length) state.hasMoreUsers = false;
      else {
        action.payload.users.map((user) => state.users.push(user));
        state.hasMoreUsers = true;
      }

      if (action.payload.users.length !== 12) state.hasMoreUsers = false;

      state.loading = false;
      state.searchUserLoading = false;
    },
    resetUserList(state) {
      state.users = [];
      state.offset = 0;
      state.page = 1;
      state.hasMoreUsers = true;
      state.open = null;
      state.userDetails = {};
      state.userEditBoxHeight = 0;
      // state.userAccess = [];
      // state.roles = [];
      // state.languages = [];

      state.loading = false;
      state.userUpdateDetails = {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        role: "",
        subRole: "",
        additionalAccess: [],
        language: "",
      };
      state.error = {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        role: "",
        subRole: "",
      };
      state.isformDataChange = false;
      state.onSubmitLoading = false;
      state.onRemoveLoading = false;
      state.removeUserPopper = false;
      state.newUser = {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        role: "",
        subRole: "",
        additionalAccess: [],
        language: defaultLanguage.en,
      };
      state.newUserError = {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        role: "",
        subRole: "",
      };
      state.newUserOpen = false;
      state.onNewUserSubmitLoading = false;
      state.isNewUserFormDataChange = false;
      state.isAdminCheck = false;

      state.isAdminCheckForUpdate = true;
    },
    setSearchUserLoading(state) {
      state.searchUserLoading = true;
    },
    setPage(state) {
      state.offset = state.page * state.pageSize;
      state.page = state.page + 1;
    },
    setUpdateBoxOpenForUser: (state, action) => {
      if (state.open === action.payload) {
        state.open = false;
        state.userEditBoxHeight = 0;
      } else state.open = action.payload;
    },
    setUserEditBoxHeight: (state, action) => {
      state.userEditBoxHeight = action.payload;
    },
    getUserDetails: (state) => {},
    setUserDetails: (state, action) => {
      if (action.payload.user.length) {
        state.userDetails = { ...action.payload.user[0] };
      }
      state.userDetailsLoading = false;

      if (Object.keys(state.userDetails).length) {
        const userData = {
          firstName: state.userDetails.user_first_name,
          lastName: state.userDetails.user_last_name,
          email: state.userDetails.user_email,
          phoneNumber: state.userDetails.user_phone
            ? state.userDetails.user_phone
            : "",
          role: state.userDetails.role_id,
          subRole: state.userDetails.sub_role_type_id,
          additionalAccess: [],
          language: state.userDetails.preferred_language_type,
        };

        if (state.userDetails.additional_access?.length) {
          state.userDetails.additional_access.split("|").map((el) => {
            if (el) {
              el.split(",").map((e) => {
                if (e) {
                  const [key, value] = e.split(":");

                  if (key === `additional_access_id`)
                    userData.additionalAccess.push(value);
                }

                return null;
              });
            }

            return null;
          });
        }
        state.userUpdateDetails = { ...userData };
      }
    },
    getUserAccessAndLanguages: () => {},
    setUserAccessAndLanguages: (state, action) => {
      if (action.payload.additional_access)
        state.userAccess = [...action.payload.additional_access];
      if (action.payload.preferred_languages)
        state.languages = [...action.payload.preferred_languages];
      if (action.payload.sub_roles)
        state.subRoles = [...action.payload.sub_roles];
    },
    getRoles: () => {},
    setRoles: (state, action) => {
      if (action.payload.data) state.roles = [...action.payload.data];
    },
    setUserUpdateDetails: (state, action) => {
      state.userUpdateDetails = { ...action.payload };
      if (
        !state.isAdminCheckForUpdate ||
        state.error.firstName.trim().length ||
        state.error.lastName.trim().length ||
        state.error.email.trim().length ||
        state.error.phoneNumber.trim().length ||
        state.error.role.trim().length ||
        state.error.subRole.trim().length
      ) {
        state.isformDataChange = false;
      } else state.isformDataChange = true;
    },
    setError: (state, action) => {
      state.error = { ...action.payload };

      if (
        !state.isAdminCheckForUpdate ||
        state.error.firstName.trim().length ||
        state.error.lastName.trim().length ||
        state.error.email.trim().length ||
        state.error.phoneNumber.trim().length ||
        state.error.role.trim().length ||
        state.error.subRole.trim().length
      ) {
        state.isformDataChange = false;
      } else state.isformDataChange = true;
    },
    putUserDetails: (state, action) => {
      state.onSubmitLoading = true;
    },
    resetUserDetails: (state, action) => {
      state.userUpdateDetails = {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        role: "",
        subRole: "",
        additionalAccess: [],
        language: "",
      };
      state.error = {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        role: "",
        subRole: "",
      };
      state.isformDataChange = false;
      state.onSubmitLoading = false;
      state.open = null;
      // state.userDetails = {};
      state.userEditBoxHeight = 0;
      state.onRemoveLoading = false;
      state.removeUserPopper = false;
      state.isAdminCheckForUpdate = true;
    },
    setRemoveUserPopper: (state, action) => {
      state.removeUserPopper = action.payload;
    },
    deleteUser: (state, action) => {
      state.onRemoveLoading = action.payload;
    },
    setNewUserDetails: (state, action) => {
      state.newUser = { ...action.payload };

      if (
        !(
          state.newUser.firstName?.trim().length &&
          state.newUser.lastName?.trim().length &&
          state.newUser.email?.trim().length &&
          state.newUser.role?.trim().length &&
          state.newUser.subRole?.trim().length &&
          state.newUser.language?.trim().length &&
          state.isAdminCheck &&
          !(
            state.newUserError.firstName?.trim().length ||
            state.newUserError.lastName?.trim().length ||
            state.newUserError.email?.trim().length ||
            state.newUserError.phoneNumber?.trim().length ||
            state.newUserError.role?.trim().length ||
            state.newUserError.subRole?.trim().length
          )
        )
      )
        state.isNewUserFormDataChange = false;
      else state.isNewUserFormDataChange = true;
    },
    setNewUserError: (state, action) => {
      state.newUserError = { ...action.payload };

      if (
        !(
          state.newUser.firstName?.trim().length &&
          state.newUser.lastName?.trim().length &&
          state.newUser.email?.trim().length &&
          state.newUser.role?.trim().length &&
          state.newUser.subRole?.trim().length &&
          state.newUser.language?.trim().length &&
          state.isAdminCheck &&
          !(
            state.newUserError.firstName?.trim().length ||
            state.newUserError.lastName?.trim().length ||
            state.newUserError.email?.trim().length ||
            state.newUserError.phoneNumber?.trim().length ||
            state.newUserError.role?.trim().length ||
            state.newUserError.subRole?.trim().length
          )
        )
      )
        state.isNewUserFormDataChange = false;
      else state.isNewUserFormDataChange = true;
    },
    postNewUser: (state, action) => {
      state.onNewUserSubmitLoading = true;
    },
    setNewUserOpen: (state, action) => {
      state.newUserOpen = action.payload;
    },
    setEmailCheck: (state, action) => {
      if (action.payload)
        state.newUserError.email =
          "There is already a user associated with this email.";
      else {
        state.newUserError.email = "";
        if (
          !(
            state.newUser.firstName.trim().length &&
            state.newUser.lastName.trim().length &&
            state.newUser.email.trim().length &&
            state.newUser.role.trim().length &&
            state.newUser.subRole.trim().length &&
            state.newUser.language.trim().length &&
            state.isAdminCheck &&
            !(
              state.newUserError.firstName.trim().length ||
              state.newUserError.lastName.trim().length ||
              state.newUserError.email.trim().length ||
              state.newUserError.phoneNumber.trim().length ||
              state.newUserError.role.trim().length ||
              state.newUserError.subRole.trim().length
            )
          )
        )
          state.isNewUserFormDataChange = false;
        else state.isNewUserFormDataChange = true;
      }
    },
    setAdminCheck: (state, action) => {
      if (action.payload)
        state.newUserError.role = "There are already two Admin-level users.";
      else {
        state.newUserError.role = "";
        state.isAdminCheck = true;

        if (
          !(
            state.newUser.firstName.trim().length &&
            state.newUser.lastName.trim().length &&
            state.newUser.email.trim().length &&
            state.newUser.role.trim().length &&
            state.newUser.subRole.trim().length &&
            state.newUser.language.trim().length &&
            state.isAdminCheck &&
            !(
              state.newUserError.firstName.trim().length ||
              state.newUserError.lastName.trim().length ||
              state.newUserError.email.trim().length ||
              state.newUserError.phoneNumber.trim().length ||
              state.newUserError.role.trim().length ||
              state.newUserError.subRole.trim().length
            )
          )
        )
          state.isNewUserFormDataChange = false;
        else state.isNewUserFormDataChange = true;
      }
    },
    checkUser: (state, action) => {
      if (action.payload.data === "USR001" && action.payload.flag === "AC")
        state.isAdminCheck = false;

      state.isNewUserFormDataChange = false;
    },
    checkAdmins: (state) => {
      state.isAdminCheckForUpdate = false;
      state.isformDataChange = false;
    },
    setAdminCheckUpdate: (state, action) => {
      if (state.userUpdateDetails.role === "USR001") {
        if (
          action.payload &&
          state.userDetails.role_id !== state.userUpdateDetails.role
        ) {
          state.error.role = "There are already two Admin-level users.";
        } else {
          state.error.role = "";
          state.isAdminCheckForUpdate = true;

          if (
            !state.isAdminCheckForUpdate ||
            state.error.firstName.trim().length ||
            state.error.lastName.trim().length ||
            state.error.email.trim().length ||
            state.error.phoneNumber.trim().length ||
            state.error.role.trim().length ||
            state.error.subRole.trim().length
          )
            state.isformDataChange = false;
          else state.isformDataChange = true;
        }
      } else if (state.userUpdateDetails.role === "USR002") {
        if (action.payload) {
          state.error.role = "";
          state.isAdminCheckForUpdate = true;

          if (
            !state.isAdminCheckForUpdate ||
            state.error.firstName.trim().length ||
            state.error.lastName.trim().length ||
            state.error.email.trim().length ||
            state.error.phoneNumber.trim().length ||
            state.error.role.trim().length ||
            state.error.subRole.trim().length
          )
            state.isformDataChange = false;
          else state.isformDataChange = true;
        } else {
          state.error.role =
            "“You are the only Admin, please add another admin before updating your role”";
        }
      }
    },
    setToggle(state) {
      state.toggle = !state.toggle;
    },
  },
});

export const {
  setSearchUserTerm,
  getAllUserList,
  setAllUserList,
  setSearchUserLoading,
  setPage,
  setClearSearch,
  setUpdateBoxOpenForUser,
  setUserDetails,
  getUserDetails,
  setUserEditBoxHeight,
  setUserAccessAndLanguages,
  getUserAccessAndLanguages,
  getRoles,
  setRoles,
  setUserUpdateDetails,
  setError,
  resetUserDetails,
  putUserDetails,
  setRemoveUserPopper,
  deleteUser,
  setNewUserError,
  setNewUserDetails,
  postNewUser,
  setNewUserOpen,
  checkUser,
  setEmailCheck,
  setAdminCheck,
  checkAdmins,
  setAdminCheckUpdate,
  resetError,
  setToggle,
  reset,
  resetUserList,
} = userListSlice.actions;

export default userListSlice.reducer;
